export default __webpack_public_path__ + "static/media/c3.ca553f54.png";